// extracted by mini-css-extract-plugin
export default {"banner":"bannerTelegram_banner__6j1Vw","logo":"bannerTelegram_logo__g6VTV","text":"bannerTelegram_text__UfiI0","button":"bannerTelegram_button__ShZqL"};